import { styled } from '@mui/material/styles';
import colors from 'assets/theme/base/colors';
import scStyled from 'styled-components';

export const DateButton = styled('button')({
    appearance: 'none',
    WebkitAppearance: 'none',
    background: 'none',
    border: 'none',
    padding: 0,
    margin: 0,
    color: colors.secondary.main,
    font: 'inherit',
    lineHeight: 'inherit',
    textAlign: 'left',
    cursor: 'pointer',
    textDecoration: 'underline',
    '&:hover': {
        textDecoration: 'underline',
        opacity: 0.85,
    },
});

export const EditIconButton = styled('button')({
    appearance: 'none',
    WebkitAppearance: 'none',
    background: 'none',
    border: 'none',
    padding: '2px',
    margin: 0,
    color: colors.secondary.main,
    cursor: 'pointer',
    width: '22px',
    height: '22px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
});

export const JointPill = styled('div')({
    color: '#57575780',
    border: '1px dashed #9B9B9B80',
    height: '26px',
    borderRadius: '1000px',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '0 1rem',
    fontSize: '0.8rem',
    fontWeight: 600,
});

export const NameCellValue = scStyled.div<{ disabled: boolean }>`
    &:hover {
        color: ${({ disabled }) => disabled ? colors.secondary : colors.primary};
        text-decoration: ${({ disabled }) => disabled ? 'none' : 'underline'};
        cursor: ${({ disabled }) => disabled ? 'default' : 'pointer'};
    }
`;

export const ArchiveModalCard = styled('div')({
    padding: '2rem',
    width: '90%',
    maxWidth: '28rem',
});

export const ErrorMessage = styled('div')({
    marginBottom: '1rem',
    padding: '0.5rem',
    backgroundColor: '#ffebee',
    borderRadius: '4px',
    color: '#d32f2f',
    fontSize: '0.875rem',
}); 